











import { Component, Vue } from "vue-property-decorator";

import BreadcrumbList, {
  BreadcrumbData,
} from "@/components/common/breadcrumb/BreadcrumbList.vue";
import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";
import PageMain from "@/components/pages/parts/PageMain.vue";
import { RouteName } from "@/consts/route";

@Component({
  components: { PageMain, FlexibleContentArea, BreadcrumbList },
})
export default class Summary20230220Page extends Vue {
  mounted(): void {
    this.hideLoading();
  }
  private get breadcrumbs(): BreadcrumbData[] {
    return [{ name: "Home", route: RouteName.Home, clickable: true }];
  }
}
